import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=21c124a8"
import script from "./ViewDetails.vue?vue&type=script&lang=js"
export * from "./ViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports